// frontend/src/hooks/useParallaxZoom.js
import { useState, useEffect, useRef } from 'react';

const useParallaxZoom = () => { // Removed default threshold, we'll handle it
    const ref = useRef(null);
    const [intersectionData, setIntersectionData] = useState({
        intersectionRatio: 0,
        isAboveViewport: false, // New state to track if element is above
        isIntersecting: false,
    });

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIntersectionData({
                    intersectionRatio: entry.intersectionRatio,
                    isAboveViewport: entry.boundingClientRect.top < 0 && !entry.isIntersecting,
                    isIntersecting: entry.isIntersecting,
                });
            },
            {
                root: null, // viewport
                rootMargin: '0px',
                // Observe all 0-1 values. rootMargin can extend observation area.
                threshold: Array.from({ length: 101 }, (_, i) => i / 100),
            }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
            observer.disconnect();
        };
    }, []); // Empty dependency array as threshold is no longer dynamic here

    // Return the ref and the comprehensive intersectionData
    return [ref, intersectionData];
};

export default useParallaxZoom;